/** The tabs of an organisation's administrative page, in the order they are shown. */
export const ADMIN_ORGANISATION_TABS = [
  "details",
  "relationships",
  "users",
  "configuration",
  "structure",
] as const;

export type AdminOrganisationTab = (typeof ADMIN_ORGANISATION_TABS)[number];

/** The tab an address segment names, or `undefined` for one it does not. */
export const adminOrganisationTabOf = (
  segment: string | undefined,
): AdminOrganisationTab | undefined =>
  ADMIN_ORGANISATION_TABS.find((tab) => tab === segment);
